import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { Payment } from '../../../../models/payment.model';
import { WidgetBillingDisplayComponent } from '../../../../shared/components/widget-displays/widget-billing-display/widget-billing-display.component';
import { SharedModule } from '../../../../shared/shared.module';
import {
  getInvoicesLoading,
  getLatestInvoiceDate,
  getLatestPayment,
  getPaymentsLoading,
  LoadInvoices,
  LoadPayments,
  State,
} from '../../../../store';

@Component({
  selector: 'app-ons-widget-billing',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetBillingDisplayComponent, SharedModule],
  template: `
    <app-widget-billing-display
      class="dimensions-stretch"
      [hyperlink]="'/billing'"
      [navigateOnClick]="navigateOnClick()"
      [loadingInvoices]="isLoadingInvoices()"
      [loadingPayments]="isLoadingPayments()"
      [invoiceDate]="invoiceDate()"
      [payment.transactionDate]="payment()?.Transaction_Date__c"
      [payment.amount]="payment()?.Transaction_Amount__c"
    ></app-widget-billing-display>
  `,
})
export class WidgetBillingComponent implements OnInit {
  readonly navigateOnClick = input<boolean>(false);

  private readonly store = inject(Store<State>);

  readonly isLoadingInvoices = toSignal<boolean>(
    this.store.select(getInvoicesLoading),
  );

  readonly isLoadingPayments = toSignal<boolean>(
    this.store.select(getPaymentsLoading),
  );

  readonly invoiceDate = toSignal<Date | null>(
    this.store.select(getLatestInvoiceDate),
  );

  readonly payment = toSignal<Payment | null>(
    this.store.select(getLatestPayment),
  );

  ngOnInit(): void {
    this.store.dispatch(new LoadPayments());
    this.store.dispatch(new LoadInvoices());
  }
}
